import Image from 'next/image';
import React, { useState } from 'react';
import { Pagination, Navigation } from 'swiper/modules';
import { SwiperSlide } from 'swiper/react';

import { TRentProductImage } from '@/entities/product';

import { DEFAULT_IMAGE_SRC, IMAGE_ALT_CUT_LENGTH } from '@/shared/constants/settings';
import { Swiper } from '@/shared/ui/swiper';
import { cutString } from '@/shared/utils/string';

import { StyledProductImageContainer, StyledImgBannerWrapper } from './styled';

type TProps = {
    images: TRentProductImage[];
    title: string;
};

export const ProductImages: React.FC<TProps> = ({ images, title }) => {
    const [img, setImage] = useState<TRentProductImage>(
        images?.find((image) => image.isMain === true) as TRentProductImage,
    );

    return (
        <StyledProductImageContainer>
            <StyledImgBannerWrapper>
                <Image src={img?.image ?? DEFAULT_IMAGE_SRC} fill alt={cutString(title, IMAGE_ALT_CUT_LENGTH)} />
            </StyledImgBannerWrapper>
            <Swiper
                modules={[Pagination, Navigation]}
                slidesPerView="auto"
                containerName="swiper-product-container"
                next="product-swiper-button-next"
                prev="product-swiper-button-prev"
                showBullets={true}
            >
                {images?.map((img: TRentProductImage, index) => (
                    <SwiperSlide className="slide-image" key={`product-image-${index}`} onClick={() => setImage(img)}>
                        <Image
                            src={img?.image ?? DEFAULT_IMAGE_SRC}
                            fill
                            alt={`${cutString(title, IMAGE_ALT_CUT_LENGTH)} изображение ${img.id}`}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </StyledProductImageContainer>
    );
};
